const searchElem = document.querySelector('.news__router--phone') as HTMLElement;
const searchBlock = document.querySelector('.news__router-block') as HTMLElement;
const backBtn = document.querySelector('.news__router--back-btn') as HTMLElement;

searchElem?.addEventListener('click', (e) => {
  e.preventDefault();
  searchElem.classList.add('news__router--phone--none');
  searchBlock.classList.remove('news__router-block--none');
});
backBtn?.addEventListener('click', (e) => {
  e.preventDefault();
  searchElem.classList.remove('news__router--phone--none');
  searchBlock.classList.add('news__router-block--none');
});
